import { Component, OnInit, Input, OnDestroy, ElementRef } from '@angular/core';
import echarts from 'echarts';
import { DatePipe } from '@angular/common';
import { format, subDays, differenceInCalendarDays } from 'date-fns';
import { _HttpClient } from '@delon/theme';
import { DialogService } from 'icc-common-lib';
import { URLS } from '../../../../shared/constant/interface';

@Component({
  selector: 'app-tiktok-data-trend',
  templateUrl: './tiktok-data-trend.component.html',
  styleUrls: ['./tiktok-data-tend.component.less'],
})
export class TiktokDataTrendComponent implements OnInit {
  constructor(private el: ElementRef, private datePipe: DatePipe, private http: _HttpClient, private dialogService: DialogService) {}

static NAME = 'icc-msg-social-video-trend';

  @Input() channelId: number;

  searchOptions = {
    indexType: 0,
    start: subDays(new Date(), 7),
    end: subDays(new Date(), 1),
  };

  postParams = {
    /* channelId: this.channelId, */
    channelId: 0,
    indexType: this.searchOptions.indexType,
    start: format(subDays(new Date(), 7), 'yyyyMMdd'),
    end: format(subDays(new Date(), 1), 'yyyyMMdd'),
  };

  dataSource: any;

  // 图谱实例
  chartIns: any;

  // 图谱展示数据
  displayDateList: Array<string>;
  displayCountList: Array<number>;

  // 数据指标 tag 列表
  dataIndicatorList = [
    { name: '播放量', targetType: 0, isSelected: true },
    { name: '点赞量', targetType: 1, isSelected: false },
    { name: '评论量', targetType: 2, isSelected: false },
    { name: '分享量', targetType: 3, isSelected: false },
  ];

  // 数据指标已选择 tag
  selectedDataIndicatorTag = '播放量';
  selectedTargetType = 0; // 用于发送请求

  // 时间选择器选择时间有误
  isRangeError: boolean;
  validateRange = {
    errorKey: '',
    errorList: [
      {
        key: 'max-range-error',
        value: '最大跨度为31天',
      },
      {
        key: 'min-range-error',
        value: '最小跨度为7天',
      },
    ],
  };

  ngOnInit() {
    this.postParams.channelId = Number(this.channelId);
    this.http.post(URLS.fetchTikTokVideoIndexStatDataTrend.url, this.postParams).subscribe(res => {
      if (res.status === 0 && res.data && res.data.length > 0) {
        this.dataSource = res.data;
        setTimeout(() => {
          this.formatData(this.dataSource);
          this.createLineChart('chart-el');
        }, 100);
      }
      window.addEventListener('resize', this.resizeCharts);
    });
  }

  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }

  // 数据指标 tag 选择处理函数
  handleClickDITag(e) {
    this.selectedDataIndicatorTag = e.target.innerText;
    for (const item of this.dataIndicatorList) {
      if (item.name === this.selectedDataIndicatorTag) {
        item.isSelected = true;
        this.selectedTargetType = item.targetType;
        this.searchOptions.indexType = item.targetType;
      } else {
        item.isSelected = false;
      }
    }
    // 销毁原图谱
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
    this.search();
  }

  /* 查询时间变更更新趋势数据 */
  handleDateChange() {
    if (this.selectDate()) {
      if (this.chartIns) {
        this.chartIns.dispose();
        this.chartIns = null;
      }
      window.removeEventListener('resize', this.resizeCharts);
      this.search();
    } else {
      this.dataSource = null;
    }
  }

  search() {
    this.postParams.indexType = this.searchOptions.indexType;
    this.postParams.start = format(this.searchOptions.start, 'yyyyMMdd');
    this.postParams.end = format(this.searchOptions.end, 'yyyyMMdd');
    this.http.post(URLS.fetchTikTokVideoIndexStatDataTrend.url, this.postParams).subscribe(res => {
      if (res.status === 0 && res.data && res.data.length > 0) {
        this.dataSource = res.data;
        setTimeout(() => {
          this.formatData(this.dataSource);
          this.createLineChart('chart-el');
        }, 100);
      } else {
        this.displayDateList = [];
        this.displayCountList = [];
        this.dataSource = null;
      }
    });
  }

  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };

  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, new Date()) > -1 || differenceInCalendarDays(current, new Date()) < -730;
  };

  selectDate() {
    const selectRange = differenceInCalendarDays(this.searchOptions.end, this.searchOptions.start);
    let errorKey = selectRange > 30 ? 'max-range-error' : selectRange < 6 ? 'min-range-error' : '';
    if (errorKey) {
      const filterErrors = this.validateRange.errorList.filter(item => item.key === errorKey);
      if (filterErrors.length) {
        this.dialogService.notification.error('查询条件', filterErrors[0].value);
        this.validateRange.errorKey = filterErrors[0].key;
        this.isRangeError = true;
      }
      return false;
    } else {
      this.isRangeError = false;
      this.validateRange.errorKey = '';
    }
    return true;
  }

  /* 处理数据源 */
  formatData(data) {
    const dateList = [];
    const countList = [];
    const lineItemLabel = {
      show: true,
      color: 'rgb(63,63,63)',
      formatter: item => {
        return item.value;
      },
    };
    data.forEach(item => {
      dateList.push(this.formatDisplayDate(item.postTime));
      countList.push({
        value: item.value,
        label: lineItemLabel,
      });
    });
    this.displayDateList = dateList;
    this.displayCountList = countList;
  }

  // 格式化显示时期 20200801 -> 2020.08.01
  formatDisplayDate(date) {
    if (typeof date === 'string') {
      let year = date.slice(0, 4);
      let month = date.slice(4, 6);
      let day = date.slice(6);
      return year + '.' + month + '.' + day;
    } else {
      date = date + '';
      let year = date.slice(0, 4);
      let month = date.slice(4, 6);
      let day = date.slice(6);
      return year + '.' + month + '.' + day;
    }
  }

  /* 生成图谱 */
  createLineChart(chartCls) {
    const elCollection = this.el.nativeElement.getElementsByClassName(chartCls);
    if (!this.chartIns && elCollection.length) {
      this.chartIns = echarts.init(elCollection[0]);
      console.log(echarts.version);
    }
    const legendNames = this.selectedDataIndicatorTag;
    const axisLabel: any = {
      textStyle: {
        color: '#B9C0D6',
      },
      formatter: '{value} ',
      margin: 10,
      rotate: 45,
    };
    if (this.displayDateList.length >= 10) {
      axisLabel.margin = 10;
      axisLabel.interval = 0;
      axisLabel.rotate = 45;
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(0,0,0,0.6)',
      },
      legend: {
        name: legendNames,
        itemHeight: 10,
        itemGap: 40,
        textStyle: {
          color: '#B9C0D6',
        },
        top: '11%',
        right: '10%',
      },
      grid: {
        x: '8%',
        width: '82%',
        y: '12%',
        top: '20%',
      },
      xAxis: [
        {
          data: this.displayDateList,
          boundaryGap: true,
          axisLine: {
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#bec4d7', // 更改坐标轴文字颜色
            },
          },
        },
      ],
      yAxis: [
        {
          name: '单位:次',
          minInterval: 1,
          nameTextStyle: {
            padding: [3, 4, 5, 6],
            color: '#B9C0D6',
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#B9C0D6',
            },
            formatter: '{value} ',
          },
        },
        {
          axisLine: {
            show: true,
            lineStyle: {
              color: '#eee',
            },
          },
        },
      ],
      series: [
        {
          name: legendNames,
          type: 'line',
          symbolSize: 1,
          itemStyle: {
            normal: {
              color: 'rgb(87,179,255)',
              label: {
                show: false,
                textStyle: {
                  color: 'rgb(87,179,255)',
                },
              },
            },
          },

          data: this.displayCountList,
        },
      ],
    });
  }
}
